export default __webpack_public_path__ + "static/media/Vienna.c8a3d55c.jpg";